import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from 'react';
import Banner from './Banner';
var StickyBanner = function StickyBanner(_ref) {
  var refElement = _ref.refElement,
    className = _ref.className,
    heading = _ref.heading,
    primaryBtn = _ref.primaryBtn,
    secondaryBtn = _ref.secondaryBtn,
    toShowCloseIcon = _ref.toShowCloseIcon,
    subCopy = _ref.subCopy;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toShow = _useState2[0],
    setToShow = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    observer = _useState4[0],
    setObserver = _useState4[1];
  useEffect(function () {
    setupObserver(refElement);
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [refElement]);
  var setupObserver = function setupObserver(ref) {
    if (observer) {
      observer.disconnect();
    }
    if (ref !== null && ref !== void 0 && ref.current) {
      var newObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setToShow(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
        });
      }, {
        rootMargin: '5px',
        threshold: 0
      });
      newObserver.observe(ref.current);
      setObserver(newObserver);
    } else {
      setToShow(true); // Show banner if no refElement is provided
    }
  };
  var close = function close() {
    if (observer && refElement !== null && refElement !== void 0 && refElement.current) {
      observer.unobserve(refElement.current);
      observer.disconnect();
    }
  };
  return React.createElement(Banner, {
    className: className || '',
    heading: heading,
    primaryBtn: primaryBtn,
    secondaryBtn: secondaryBtn,
    toShowCloseIcon: toShowCloseIcon,
    subCopy: subCopy,
    toClose: close,
    toShow: toShow
  });
};
export default StickyBanner;